import * as actionTypes from '../actions/actionTypes';

const initialState={
    
    drivers: [],
    loading: false,
    existing: null
}

const reducer=(state=initialState, action)=>{
    
    switch (action.type){
            
        case actionTypes.FETCH_DRIVERS_START:
            return{
                
                ...state,
                loading:true
            }
                
            
        case actionTypes.FETCH_DRIVERS_SUCCESS:
            return{
                
                ...state,
                drivers: action.drivers,
                loading: false
            }
                
            
        case actionTypes.FETCH_DRIVERS_FAIL:
            return{
                
                ...state,
                loading: false, //could handle action.error here also, but then we would need another state property and would need to use it in the right component. Not smart to turn loading to true either because then it would just load without the user knowing what is happening
            }
            
             case actionTypes.SET_STATUS:
            return{
                
                ...state,
                existing: action.value
            }
            
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/fetch.js